export const sessionDebugEnabled = () => {
  if (process.env.NODE_ENV !== "production") return true;
  try {
    return localStorage.getItem("healink:debugSession") === "1";
  } catch {
    return false;
  }
};
